/**
 * Billing tab – placeholder until backend and design are defined.
 */
import { Box, Paper, Typography } from '@mui/material';
import WorkflowSessionBar from '../Workflow/WorkflowSessionBar';

export default function BillingPage() {
  return (
    <Box sx={{ p: 2, height: '100%', minHeight: 0, overflow: 'auto' }}>
      <Box sx={{ mb: 2 }}>
        <WorkflowSessionBar />
      </Box>
      <Paper variant="outlined" sx={{ p: 3, maxWidth: 800 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: '#212121' }}>
          Billing
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Billing section – to be implemented with backend support.
        </Typography>
      </Paper>
    </Box>
  );
}
